import { render, staticRenderFns } from "./iqForm.vue?vue&type=template&id=c6629936&scoped=true&"
import script from "./iqForm.vue?vue&type=script&lang=js&"
export * from "./iqForm.vue?vue&type=script&lang=js&"
import style0 from "./iqForm.vue?vue&type=style&index=0&id=c6629936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6629936",
  null
  
)

component.options.__file = "iqForm.vue"
export default component.exports